/** 与网关约定一致：1000 / 0 表示成功 */
export function isSysApiSuccess(code: number): boolean {
  return code === 1000 || code === 0;
}

/** 刷新令牌失败等场景需重新登录（Apifox：2003） */
export const SYS_CODE_RELOGIN = 2003;
